import Pathword5x5 from './Pathword5x5';

export default Pathword5x5;